import { SFMedia, useSFMediaQuery } from 'sfui';

export const useDesktopQuery = () =>
  useSFMediaQuery(`(min-width: ${SFMedia.SM_WIDTH}px)`);
